export default "__VITE_ASSET__74871aea__"